import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">The Catholic Church in Poland</p>
        <h1>Catholic Poland</h1>
        <p className="lede">
          Poland remains one of the most Catholic nations on earth: roughly 36.9 million Catholics, about 97.6% of the population, supported by one of Europe's largest and most active clergies.
        </p>
        <div className="cta-row">
          <a href="#stats">
            By the Numbers
          </a>
          <a href="#pilgrimage" className="secondary">
            Pilgrimage
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>A Nation of Believers</h2>
          <p>
            As of 2026, Poland counts approximately 36,932,000 Catholics -- 97.6% of its 37,840,000 population -- served by 10,393 parishes and 29,304 priests.
          </p>
        </article>
        <article>
          <h2>Strong Regional Dioceses</h2>
          <p>
            The Archdiocese of Krakow alone reports 1.57 million Catholics (96.8% of its population) across 448 parishes; the Diocese of Tarnow reports 99.4% Catholic affiliation.
          </p>
        </article>
        <article>
          <h2>Living Pilgrimage Traditions</h2>
          <p>
            Poland's pilgrimage culture remains active into 2026, with organized international pilgrimages continuing to draw Catholic travelers to its major shrines and dioceses.
          </p>
        </article>
      </section>

      <section className="section" id="structure">
        <h2>Dioceses & Current Leadership</h2>
        <p className="section-sub">Poland has 152 bishops and 42 Roman Rite dioceses.</p>
        <div className="directory-list">
          <article className="directory-item">
            <h3>Archdiocese of Warsaw</h3>
            <p>Archbishop Adrian Joseph Galbas, Metropolitan since December 2024</p>
          </article>
          <article className="directory-item">
            <h3>Archdiocese of Katowice</h3>
            <p>Archbishop Andrzej Przybylski, appointed August 29, 2025</p>
          </article>
          <article className="directory-item">
            <h3>Diocese of Wloclawek</h3>
            <p>One of Poland's historic central dioceses</p>
          </article>
          <article className="directory-item">
            <h3>Diocese of Tarnow</h3>
            <p>99.4% of its population reported as Catholic</p>
          </article>
        </div>
      </section>

      <section className="section" id="news">
        <h2>Latest News</h2>
        <p className="section-sub">Recent, sourced developments -- updated as new stories are verified.</p>
        <div className="news-list">
          <article className="news-item">
            <p className="news-date">June 29, 2026</p>
            <h3>Polish and Ukrainian Catholic leaders issue joint appeal</h3>
            <p>Polish Cardinals Grzegorz Rys, Konrad Krajewski, and Kazimierz Nycz joined Ukrainian Catholic leaders in a joint statement calling for de-escalation of rising tensions between Ukrainians and Poles.</p>
            <p className="news-source">Source: The Pillar (pillarcatholic.com)</p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default App;
